<template>
  <div class="repair-items-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model  class="app-form"  ref="form"  :model="form"  :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" >
      <a-form-model-item label="报修项目名称" prop="name">
        <a-input  v-model="form.name" placeholder="请输入报修项目名称"  allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="报修类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="value.value" v-for="value in typeOptions" :key="value.value">{{value.name}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="应用社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择应用社区">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
  import CommunityService from '@/io/community.js';
  import RepairItemsService from '@/io/repair_items.js';

  export default {
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: null,
          type: null,
          community: []
        },
        rules: {
          name: [
            {
              required: true,
              message: "请输入报修项目名称",
            },
          ],
          type: [
            {
              required: true,
              message: "请选择报修类型",
            },
          ],
          community: [
            {
              required: true,
              message: '请选择应用社区'
            },
          ],
        },
        communityOptions: [],
        typeOptions: [],
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          Promise.all([
            this.initCommunity(),
            this.initType()
          ]).then(() => {
            this.initPage();
          });
        },
        immediate: true,
      },
    },
    methods: {
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initType() {
        return RepairItemsService.type().then(res => {
          this.typeOptions = res.repair_types;
        }).catch(err => {});
      },
      initPage() {
        if (this.id) {
          RepairItemsService.info(this.id).then((res) => {
            this.form.name = res.repair_item_name;
            this.form.type = res.repair_item_type;
            this.form.community = res.community_ids;
          });
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            RepairItemsService.edit(
              this.id,
              this.form.name,
              this.form.type,
              this.form.community
            )
            .then((res) => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            })
            .catch((err) => {});
          } else {
            RepairItemsService.add(
              this.form.name,
              this.form.type,
              this.form.community
            )
            .then((res) => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            })
            .catch((err) => {});
          }

        });
      },
      cancel() {
        this.$router.push({
          name: 'RepairItems'
        });
      },
    },
  };
</script>

<style lang="less" scoped>

</style>